import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

interface PhotoFeedbackImage {
    value: string;
    width?: number;
    height?: number;
}

interface PhotoFeedbackGalleryData {
    images: PhotoFeedbackImage[];
    selectedIndex?: number;
    title?: string;
    addedDate?: string;
    isSignature?: boolean;
}

@Component({
    selector: 'app-photo-feedback-gallery',
    templateUrl: './photo-feedback-gallery.component.html',
    styleUrls: ['./photo-feedback-gallery.component.scss']
})
export class PhotoFeedbackGalleryComponent implements OnInit, OnDestroy {

    @Input('data') data: PhotoFeedbackGalleryData;
    @Output('onClose') onClose = new EventEmitter<void>();

    currentIndex = 0;
    showSidepanel = false;

    private keyListener = (event: KeyboardEvent) => {};

    ngOnInit() {
        this.currentIndex = this.data.selectedIndex || 0;

        setTimeout(() => {
            this.showSidepanel = true;
        });

        this.keyListener = (event: KeyboardEvent) => {
            if (!this.data.images || !this.data.images.length) return;

            if (event.key === 'ArrowRight') {
                this.showNextImage();
            }

            if (event.key === 'ArrowLeft') {
                this.showPreviousImage();
            }

            // Keep these keys from scrolling the panel behind the gallery
            if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown'].indexOf(event.key) !== -1) {
                event.preventDefault();
            }
        };
        window.addEventListener('keydown', this.keyListener);
    }

    ngOnDestroy() {
        // Always unlock the base side panel, whichever way the gallery got closed
        const basePanel = document.getElementById('side-panel');
        if (basePanel) {
            basePanel.classList.remove('pfg-base-blocked');
        }
        window.removeEventListener('keydown', this.keyListener);
    }

    openImage(index: number) {
        this.currentIndex = index;
    }

    close() {
        this.onClose.emit();
    }

    onPanelClose() {
        this.close();
    }

    showNextImage() {
        if (!this.data.images || !this.data.images.length) return;
        this.currentIndex = (this.currentIndex + 1) % this.data.images.length;
    }

    showPreviousImage() {
        if (!this.data.images || !this.data.images.length) return;
        this.currentIndex = (this.currentIndex - 1 + this.data.images.length) % this.data.images.length;
    }

    async downloadImg(imageSrc: string) {
        const image = await fetch(imageSrc);
        const imageBlob = await image.blob();
        const imageURL = URL.createObjectURL(imageBlob);
        const link = document.createElement('a');
        link.href = imageURL;
        link.download = imageSrc.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
